// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat {
  display: flex;
  flex-direction: column;
  height: min(62vh, 560px);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.chat-log {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 16px;
  overflow-y: auto;
  background: var(--bg);
}

.chat-loading {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chat-empty {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 9px;
  padding: 20px;
}

.chat-empty strong {
  font-family: var(--font-display);
  font-size: 0.98rem;
}

.chat-empty p {
  max-width: 320px;
  font-size: 0.86rem;
  line-height: 1.6;
  color: var(--muted);
}

.chat-msg {
  max-width: 78%;
  padding: 10px 13px;
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
}

.chat-msg p {
  font-size: 0.9rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.chat-mine {
  align-self: flex-end;
  background: var(--brand);
  color: #fff;
  border-bottom-right-radius: 5px;
}

.chat-theirs {
  align-self: flex-start;
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--border);
  border-bottom-left-radius: 5px;
}

.chat-pending {
  opacity: 0.75;
}

.chat-time {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 4px;
  font-size: 0.68rem;
}

.chat-mine .chat-time {
  color: rgba(255, 255, 255, 0.8);
}

.chat-theirs .chat-time {
  color: var(--muted2);
}

.chat-retry {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 0;
  background: none;
  padding: 0;
  font-size: 0.68rem;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}

.chat-form {
  display: flex;
  gap: 9px;
  padding: 11px 12px;
  border-top: 1px solid var(--border);
  background: var(--surface);
}

.chat-input {
  flex: 1 1;
  min-width: 0;
  padding: 11px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-pill);
  font-family: var(--font-body);
  font-size: 0.92rem;
  color: var(--text);
}

.chat-input:focus {
  outline: none;
  border-color: var(--brand);
  box-shadow: 0 0 0 3px var(--brand-100);
}

.chat-send {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 50%;
  background: var(--brand);
  color: #fff;
  cursor: pointer;
  transition: background 0.2s;
}

.chat-send:hover:not(:disabled) {
  background: var(--brand-700);
}

.chat-send:disabled {
  opacity: 0.5;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/app/order/ChatPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".chat {\n  display: flex;\n  flex-direction: column;\n  height: min(62vh, 560px);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.chat-log {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  padding: 16px;\n  overflow-y: auto;\n  background: var(--bg);\n}\n\n.chat-loading {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.chat-empty {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 9px;\n  padding: 20px;\n}\n\n.chat-empty strong {\n  font-family: var(--font-display);\n  font-size: 0.98rem;\n}\n\n.chat-empty p {\n  max-width: 320px;\n  font-size: 0.86rem;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n.chat-msg {\n  max-width: 78%;\n  padding: 10px 13px;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n}\n\n.chat-msg p {\n  font-size: 0.9rem;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.chat-mine {\n  align-self: flex-end;\n  background: var(--brand);\n  color: #fff;\n  border-bottom-right-radius: 5px;\n}\n\n.chat-theirs {\n  align-self: flex-start;\n  background: var(--surface);\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-bottom-left-radius: 5px;\n}\n\n.chat-pending {\n  opacity: 0.75;\n}\n\n.chat-time {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: 4px;\n  font-size: 0.68rem;\n}\n\n.chat-mine .chat-time {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.chat-theirs .chat-time {\n  color: var(--muted2);\n}\n\n.chat-retry {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: 0;\n  background: none;\n  padding: 0;\n  font-size: 0.68rem;\n  color: #fff;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.chat-form {\n  display: flex;\n  gap: 9px;\n  padding: 11px 12px;\n  border-top: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.chat-input {\n  flex: 1;\n  min-width: 0;\n  padding: 11px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-pill);\n  font-family: var(--font-body);\n  font-size: 0.92rem;\n  color: var(--text);\n}\n\n.chat-input:focus {\n  outline: none;\n  border-color: var(--brand);\n  box-shadow: 0 0 0 3px var(--brand-100);\n}\n\n.chat-send {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border: 0;\n  border-radius: 50%;\n  background: var(--brand);\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.chat-send:hover:not(:disabled) {\n  background: var(--brand-700);\n}\n\n.chat-send:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
